<template>
    <div>
        <div class="my-editInfo" v-if="!isWeixin">
            <div class="bd">
                <div class="sq-notice">
                    <div class="weui-msg">
                        <div class="weui-msg__icon-area">
                            <i class="el-icon-warning" style="color: #2b94ff;font-size:100px">
                            </i>
                        </div>
                        <div class="weui-msg__text-area">
                            <h2 class="weui-msg__title">温馨提示</h2>
                            <p class="weui_msg__desc">{{notice}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="my-editInfo" v-if="isWeixin">
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                appId: '',
                deptId: '',
                userId: '',
                notice: '请在微信客户端打开链接!',
                isWeixin: false,
                code: '',
                user: {},
            };
        },
        created: async function () {
            document.title = "用户授权"
            this.deptId = this.$route.query.deptId
            this.userId = this.$route.query.userId
            await this.panduan()
            if (this.isWeixin) {
                await this.getFwGzh()
                if (this.appId) {
                    this.code = ''
                    await this.getCode()
                }
            }
        },

        methods: {
            panduan() {
                let that = this;
                var ua = navigator.userAgent.toLowerCase(); //判断是否是微信浏览器
                var isWeixin = ua.indexOf("micromessenger") != -1; //判断是否
                this.isWeixin = isWeixin
                if (!isWeixin) {
                    return false;
                }
            },

            async getFwGzh() {
                let res = await this.$get("/fw/getFwGzh", {deptId: this.deptId})
                if (res.code == 200) {
                    this.appId = res.gzhInfo.gzhAppid
                } else {
                    this.$notify({type: 'danger', message: res.message});
                }
            },

            async fwUserBd(code) {
                let data = {
                    code: code,
                    deptId: this.deptId,
                    userId: this.userId,
                    bdType:"1"
                }
                let res = await this.$post("/fw/fwBdUser", data)
                if (res.code == 200) {
                    window.location.href = `https://vipyd.fanboshi.net/#/account`
                } else {
                    this.$notify({type: 'danger', message: res.message});
                }
            },
            getCode() { // 非静默授权，第一次有弹框
                const code = this.getUrlParam("code"); // 截取路径中的code
                this.code = code
                if (this.code == null || this.code === '') { // 如果没有code，则去请求
                    var local = window.location.href // 获取页面url
                    var appid = this.appId
                    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=123&connect_redirect=1#wechat_redirect`
                } else {
                    this.fwUserBd(this.code)
                }
            },

            // 编码函数
            getUrlParam(name) {
                var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
                var r = window.location.search.substr(1).match(reg); //匹配目标参数
                if (r != null) return unescape(r[2]);
                return null; //返回参数值
            },
        },
    };

</script>

<style lang="scss" scoped>
    .my-editInfo {
        margin: 0 auto;
        height: 100%;
        /*background-color: #EDEDED;*/
        background-size: 100% 100%;
    }

    .miaoshu {
        display: block;
        font-size: 13px;
        text-align: center;
        height: 68px;
        line-height: 68px;
    }

    .van-cell {
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        box-sizing: border-box;
        width: 100%;
        padding: 0.26667rem 0.42667rem;
        overflow: hidden;
        color: #323233;
        font-size: 0.37333rem;
        line-height: 0.64rem;
        background-color: #fff;
        border-bottom: #dddddd solid 1px;
    }

    .bd {
        width: 65%;
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .bd-content {
        width: 100%;
        padding-top: 25px;
        padding-bottom: 25px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        background-color: #fff;
    }

    .bd-content-wai {
        width: 88%;
    }

    .imgs {
        width: 70px;
        height: 70px;
        position: absolute;
        top: -35px;
        left: 38%;
    }

    .res {
        color: rgb(153, 153, 153);
        font-weight: bold;
        font-size: 13px;
        background-color: rgb(255, 255, 255);
        margin: 0 auto;
        line-height: 46px;
        text-align: center;
        box-shadow: 0 3px 3px rgba(21, 62, 78, 0.8);
        margin-top: 20px;
    }

    .regis {
        color: rgb(52, 119, 182);
        cursor: pointer;
    }

    .van-button {
        height: 32px;
    }

    .van-button--primary {
        color: #fff;
        background-color: #8359F9;
        border: 1px solid darkgray;
    }

    ::v-deep .van-radio__icon {
        display: inline-block;
        vertical-align: middle;
        line-height: 20px;
        font-size: 15px;
    }

    .sq-index {
        overflow: hidden;
    }

    .sq-notice {
        margin: auto;
        font-size: 18px;
        text-align: center;
        margin-top: 23%;
    }

    .weui-msg {
        padding-top: 36px;
        text-align: center;
    }

    .weui-msg__icon-area {
        margin-bottom: 30px;
    }

    .weui-icon_msg {
        font-size: 93px;
    }

    .weui-icon-info {
        font-size: 23px;
        color: #10aeff;
    }

    .weui-msg__text-area {
        margin-bottom: 25px;
        padding: 0 20px;
    }

    .weui-msg__title {
        margin-bottom: 5px;
        font-weight: 400;
        font-size: 20px;
    }

    .weui_msg__desc {
        margin-top: 16px;
    }

    .md-items {
        display: flex;
        flex-direction: column;
        overflow: auto;
        height: 100%;
        background-color: #FFFFFF;
        padding-top: 12px;
        padding-bottom: 3px;
    }

    .md-bt {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        font-size: 15px;
        border-bottom: #dddddd solid 1px;
        padding: 10px;
    }

    .md-item {
        width: 90%;
        margin: auto;
        padding: 8px 20px;
        font-size: 13px;
        display: flex;
        flex-direction: column;
        background-color: #eeeeee;
        border-radius: 3px;
        margin-bottom: 10px;
    }

    .fw-mduser {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .jinruEmp {
        padding: 3px 8px;
        background-color: #2b94ff;
        border-radius: 3px;
        color: #ffffff;
    }

    .mdbt {
        font-size: 13px;
        display: block;
        text-align: center;
        margin-bottom: 20px;
    }


</style>
